import React from "react";
import { fullMonthFormatDate, signedLockedAccess } from "../../../../utils";
import style from "./assessmentNotes.module.scss";
import { PERMISSIONS } from "../../../../constants/permissions";

export const NoteItem = ({ data, assessmentStage, onDelete, hasPermission }) => (
  <div className={style.entered_notes}>
    <div className="d-flex justify-content-between align-items-center">
      <div className={style.post_details}>
        <span className={style.creater_name}>{data.createdBy}</span> | <span>{fullMonthFormatDate(data.createdDate)}</span> |{" "}
        <span>{data.createdByRole}</span>
      </div>

      <button className={`btn ${style.delete_icon}`} type="button" onClick={() => onDelete(data)} disabled={!signedLockedAccess(assessmentStage) || !hasPermission(PERMISSIONS.ASSESSMENT_NOTE_DELETE)}>
        <i className="fa fa-trash fa-lg" />
      </button>
    </div>

    <div className={style.notes_text}>{data?.notes === "" ? "Unknown" : data?.notes?.split("\n").map((str) => <div key={str}>{str}</div>)}</div>
  </div>
);
